export const achievementsDPRoot = 'Credentials|Achievements';
